import { render } from "./DataTable.vue?vue&type=template&id=04c59c6f"
import script from "./DataTable.vue?vue&type=script&lang=js"
export * from "./DataTable.vue?vue&type=script&lang=js"

import "./DataTable.vue?vue&type=style&index=0&id=04c59c6f&lang=scss"

import exportComponent from "/var/www/production/releases/51/app.jumpfeed.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QTable from 'quasar/src/components/table/QTable.js';
import QSpinner from 'quasar/src/components/spinner/QSpinner.js';
import QHeader from 'quasar/src/components/header/QHeader.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QChip from 'quasar/src/components/chip/QChip.js';
import QTr from 'quasar/src/components/table/QTr.js';
import QTh from 'quasar/src/components/table/QTh.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QTd from 'quasar/src/components/table/QTd.js';
import QTabs from 'quasar/src/components/tabs/QTabs.js';
import QTab from 'quasar/src/components/tabs/QTab.js';
import QTabPanels from 'quasar/src/components/tab-panels/QTabPanels.js';
import QTabPanel from 'quasar/src/components/tab-panels/QTabPanel.js';
import QList from 'quasar/src/components/item/QList.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QCheckbox from 'quasar/src/components/checkbox/QCheckbox.js';
import QItemLabel from 'quasar/src/components/item/QItemLabel.js';
import QExpansionItem from 'quasar/src/components/expansion-item/QExpansionItem.js';
import QBadge from 'quasar/src/components/badge/QBadge.js';
import QSelect from 'quasar/src/components/select/QSelect.js';import Ripple from 'quasar/src/directives/Ripple.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QTable,QSpinner,QHeader,QBtn,QTooltip,QInput,QIcon,QChip,QTr,QTh,QCard,QTd,QTabs,QTab,QTabPanels,QTabPanel,QList,QItem,QItemSection,QCheckbox,QItemLabel,QExpansionItem,QBadge,QSelect});qInstall(script, 'directives', {Ripple});
